
<p-tabView [scrollable]="true" [activeIndex]="supportTabIndex" (onChange)="changeTab($event)">
    <p-tabPanel header="{{ 'CALENDAR' | translate }}">
        <app-calendar></app-calendar>
    </p-tabPanel>
    <p-tabPanel header="{{ 'SCENARIOS' | translate }}">
        <app-scenarios-list></app-scenarios-list>
    </p-tabPanel>
    <p-tabPanel header="{{ 'SCHEDULES' | translate }}">
        <app-schedules-list></app-schedules-list>
    </p-tabPanel>
    <p-tabPanel header="{{ 'EXCLUSIONS_CALENDARS' | translate }}">
        <app-calendars-list></app-calendars-list>
    </p-tabPanel>
</p-tabView>
